import { render, staticRenderFns } from "./ProductItemfive.vue?vue&type=template&id=019a6a28&scoped=true"
import script from "./ProductItemfive.vue?vue&type=script&lang=js"
export * from "./ProductItemfive.vue?vue&type=script&lang=js"
import style0 from "./ProductItemfive.vue?vue&type=style&index=0&id=019a6a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a6a28",
  null
  
)

export default component.exports